import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { onEnter, onExit } from "../../../config/customModalFunctions";

function FilterModal(props){
  const toggle = () => {
    props.closeModal();
  }
    const {
      className,
    } = props;

    if (!props.showModal) {
      return null;
    }
    return (
      <Modal
        isOpen={props.showModal}
        toggle={toggle}
        className={className}
        onEnter={ onEnter }
        onExit={ onExit }
        returnFocusAfterClose={false}
        centered
      >
        <ModalHeader toggle={toggle}>
          <FormattedMessage id={props.modalTitle} />
        </ModalHeader>
        <ModalBody>
          {props.children}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => {
            props.confirmationYes();
          }}
          >
            <FormattedMessage id="button.apply" />
          </Button>
          <Button color="secondary" onClick={toggle}>
            <FormattedMessage id="button.cancel" />
          </Button>
        </ModalFooter>
      </Modal>
    );
}

FilterModal.defaultProps = {
  confirmationYes: null,
  show: false,
  modalTitle: "components.layout.filter.modal_title",
};

export { FilterModal };
